var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"text-uppercase",attrs:{"color":_vm.getStatusColor(_vm.status.name),"text-color":"white","label":""}},[_vm._v(" "+_vm._s(_vm.status.localizedText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }